import { useTranslation } from "react-i18next";
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "../scss/_footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/hci4goodlogo.png";
import {RiPhoneFill} from "@remixicon/react";

function Footer(){
    const { t } = useTranslation("footerTranslationContainer");
    return (
        <div className="footer-container">
            <div className="footer-main">
                <div className="footer-contact">
                    <img className="logo" src={logo} alt="logo" />
                    <p>{t("address_line_1")}</p>
                    <p>{t("address_line_2")}</p>
                    <p className="phone-number"><RiPhoneFill size={20} /> (902) 494-2093</p>
                </div>
                <div className="footer-content">
                    <div className="footer-subscribe">
                        <h4>{t("subscribe_title")}</h4>
                        <p>{t("subscribe_text")}</p>
                        <div className="subscribe-input">
                            <input type="email" id="email" className="subscribe-email" placeholder={t("email_placeholder")}></input>
                            <motion.button className="subscribe-button"
                                whileHover={{ scale: 1.05 }}
                            >{t("subscribe_title")}</motion.button>
                        </div>
                        <div className="social-icons">
                            <motion.a href="https://www.instagram.com/hci_4_good/" whileHover={{scale:1.2}}>
                                <FontAwesomeIcon icon={faInstagram} />
                            </motion.a>
                            <motion.a href="https://www.facebook.com/profile.php?id=61577992934450" whileHover={{scale:1.2}}>
                                <FontAwesomeIcon icon={faFacebookF} />
                            </motion.a>
                            <motion.a href="mailto:hci4goodresearch@gmail.com" whileHover={{scale:1.2}}>
                                <FontAwesomeIcon icon={faEnvelope} />
                            </motion.a>
                        </div>
                    </div>
                    <div className="footer-dal-lab">
                        <div className="footer-dal">
                            <h4>{t("dalhousie_university")}</h4>
                            <Link to="https://www.dal.ca/about.html" className="footer-link" target="_blank">{t("about")}</Link>
                            <Link to="https://www.dal.ca/about/contact-us.html" className="footer-link" target="_blank">{t("contact")}</Link>
                            <Link to="https://www.dal.ca/news/media.html" className="footer-link" target="_blank">{t("media_centre")}</Link>
                            <Link to="https://www.dal.ca/privacy.html" className="footer-link" target="_blank">{t("privacy_statement")}</Link>
                        </div>
                        <div className="footer-lab">
                            <h4>{t("lab_title")}</h4>
                            <Link to="AboutUs" className="footer-link">{t("about_the_lab")}</Link>
                            <Link to="Career" className="footer-link">{t("apply_to_join")}</Link>
                            <Link to="OurBlog" className="footer-link">{t("blog")}</Link>
                            {/*Update donate link*/}
                            <Link to="/" className="footer-link">{t("donate")}</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p>&copy;{t("copyright")}</p>

            </div>
        </div>
    );
}
export default Footer;
